"use client";

import Image from "next/image";
import Link from "next/link";
import "./BlogList.css";
import { useState } from "react";
import { useRef } from "react";
import { FaArrowRightLong } from "react-icons/fa6";

export const BlogList = ({ blogList }) => {
    const [showAll, setShowAll] = useState(false);
    const myref = useRef();
    let blogLists = showAll ? blogList : blogList.slice(0, 18);
    let data = blogList.length;

    return (
        <>
            <div className="grid w-full grid-cols-1 md:gap-10 gap-5 md:grid-cols-2 2xl:grid-cols-3">
                {blogLists?.map((blog, ind) => {
                    return (
                        <Link
                            href={`/blog/${blog?.attributes?.slug}`}
                            key={blog?.attributes?.slug || ind}
                            className="group"
                        >
                            <div className="grid w-full grid-cols-1 gap-1 hover:scale-105 transition-all duration-300 ease-in-out">
                                <div
                                    className="relative w-full rounded-xl cursor-pointer"
                                    ref={myref}
                                >
                                    <Image
                                        className="object-cover py-1 transition-all duration-300 ease-in-out drop-shadow-sm w-full rounded-xl"
                                        src={`${process.env.NEXT_PUBLIC_STRAPI_URL}${blog?.attributes?.titleImage?.data?.attributes.url}`}
                                        alt={blog?.attributes?.title}
                                        width={300}
                                        height={300}
                                        quality={100}
                                        loading="lazy"
                                        placeholder="blur"
                                        blurDataURL="https://img.freepik.com/free-vector/silver-blurred-background_1034-253.jpg"
                                        sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                                    />
                                </div>

                                <div className="py-2 text-lg transition-all duration-300 ease-in-out drop-shadow-sm text-ellipsis text-black">
                                    <div className="flex md:justify-start gap-2 flex-wrap">
                                        {blog?.attributes?.tags?.data?.map(
                                            (itemName, ind) => (
                                                <h2
                                                    key={
                                                        itemName?.attributes
                                                            ?.uid || ind
                                                    }
                                                    className="bg-[#EFE8FC] text-[#410ead] md:py-2 py-1 md:px-4 px-2 text-sm w-fit rounded-md"
                                                >
                                                    {itemName?.attributes?.name}
                                                </h2>
                                            )
                                        )}
                                    </div>

                                    <h3 className="text-black font-medium my-2 text-sm md:text-base text-start  changeText">
                                        {blog?.attributes?.title}
                                    </h3>
                                    <div className="text-[#747474] md:text-sm text-xs text-start ">
                                        {blog?.attributes?.seo?.metaDescription}
                                    </div>
                                </div>
                            </div>
                        </Link>
                    );
                })}
            </div>
            {data > 18 && (
                <div className="flex justify-end mt-10">
                    {!showAll ? (
                        <div
                            className={` common-blue-button-style flex items-center gap-2 cursor-pointer`}
                            onClick={() => setShowAll(!showAll)}
                        >
                            Read More
                            <FaArrowRightLong />
                        </div>
                    ) : (
                        <div
                            className={` common-blue-button-style flex items-center gap-2 cursor-pointer`}
                            onClick={() => {
                                setShowAll(!showAll);
                                window.scrollTo({ top: 0, behavior: "smooth" });
                            }}
                        >
                            <FaArrowRightLong className="rotate-180" />
                            Read Less
                        </div>
                    )}
                </div>
            )}
        </>
    );
};
